/*
 *  TTTech nerve-management-system
 *  Copyright(c) 2021. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

import BaseApiService from './base.api-service';

const PATH = '/crm/profile';
const PERSONAL_PROFILE = '/crm/personal-profile';
const PREFERENCES = '/crm/profiles/me/preferences';
const LIST_USER_PROFILES = '/crm/profiles';

class UsersApiService extends BaseApiService {
  getUser(id) {
    return this.get(`${PATH}/${id}`, { authRequired: true });
  }

  updateUser(formData, id) {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return this.put(`${PATH}/${id}`, formData, options, { authRequired: true });
  }

  createUser(formData) {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return this.post(PATH, formData, options, { authRequired: true });
  }

  updatePersonalProfile(data) {
    return this.put(`${PERSONAL_PROFILE}`, data, { authRequired: true });
  }

  getPersonalProfile() {
    return this.get(`${PERSONAL_PROFILE}`, { authRequired: true });
  }

  fetchUsers(params) {
    return this.get(LIST_USER_PROFILES, params, { authRequired: true });
  }

  remove(id) {
    return this.delete(`${PATH}/${id}`, { authRequired: true });
  }

  getProfilePreferences() {
    return this.get(PREFERENCES, { authRequired: true });
  }

  updateProfilePreferences(data) {
    return this.patch(PREFERENCES, data, { authRequired: true });
  }
}

export default new UsersApiService();
